module.exports = __webpack_public_path__ + "img/svg/position.ecbb87d79feebf3b2b7a786e60739188.svg";